import { Injectable } from '@angular/core';
import { filter, firstValueFrom, Subject } from 'rxjs';
import { PromptActionPayload } from './prompt.model';

@Injectable()
export class PromptService {
  showModal$ = new Subject<string>();
  userAction$ = new Subject<PromptActionPayload>();

  constructor() {}

  prompt = (modalId: string) => {
    this.showModal$.next(modalId);
    return firstValueFrom(this.userAction$.pipe(filter(payload => payload?.modalId === modalId)));
  };
}
